import { HttpClient } from '../httpClient';
import RolesResponse from '../responses/rolesResponse';

const httpClient = new HttpClient();

export const getRoles = async () => {
  return httpClient.get<RolesResponse>({
    url: '/v1/roles',
    requiresToken: true,
  });
};

/**
 * Gets the roles available to the specified user
 * @returns 
 */
export const getAvailableRoles = async () => {
  return httpClient.get<RolesResponse>({
    url: '/v1/roles/available',
    requiresToken: true,
  });
};